var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.30708 0.82625C5.16583 0.70875 5.88749 1.23417 6.22916 1.91708L7.06958 3.5975C7.53583 4.53 7.26791 5.62417 6.56124 6.3125C6.14374 6.71875 5.72416 7.18292 5.48083 7.5925C5.46471 7.62169 5.45968 7.65573 5.46666 7.68833C5.69166 8.9075 6.51791 10.1121 7.25499 10.9758C7.29207 11.017 7.34045 11.0464 7.39409 11.0602C7.44774 11.0741 7.50428 11.0718 7.55666 11.0538L9.21291 10.5363C9.65906 10.3968 10.1382 10.4039 10.58 10.5566C11.0218 10.7093 11.403 10.9994 11.6679 11.3846L12.8667 13.1279C13.1917 13.6013 13.3562 14.2429 13.1071 14.86C12.8846 15.4113 12.4542 16.2063 11.6712 16.735C10.8587 17.2833 9.74583 17.4917 8.28958 16.9925C6.66249 16.4342 5.12541 15.0342 3.85083 13.2438C2.56874 11.4421 1.51333 9.19167 0.873328 6.845C0.268745 4.62917 0.633745 3.1375 1.49291 2.17708C2.32166 1.25042 3.50916 0.935834 4.30708 0.82625ZM5.29749 2.38292C5.10708 2.0025 4.76749 1.81458 4.44874 1.85833C3.73999 1.95583 2.85249 2.21958 2.26958 2.87167C1.71708 3.48958 1.33458 4.57792 1.87791 6.57083C2.48833 8.8075 3.49333 10.945 4.69958 12.6396C5.91333 14.345 7.2925 15.5492 8.62749 16.0071C9.81708 16.415 10.5817 16.2133 11.0883 15.8717C11.6242 15.5096 11.9537 14.9342 12.1412 14.47C12.2271 14.2575 12.19 13.9825 12.0083 13.7183L10.8096 11.975C10.6709 11.7732 10.4712 11.6212 10.2398 11.5412C10.0084 11.4612 9.75745 11.4574 9.52374 11.5304L7.86749 12.0479C7.37249 12.2025 6.81499 12.0646 6.46291 11.6521C5.69583 10.7533 4.71833 9.375 4.44208 7.87708C4.38927 7.59635 4.44021 7.306 4.58541 7.06C4.90124 6.52917 5.40124 5.98792 5.83416 5.56625C6.25708 5.15458 6.37708 4.54208 6.13791 4.06333L5.29749 2.38333V2.38292Z",
    fill: "url(#paint0_linear_87_401)",
    stroke: "url(#paint1_linear_87_401)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_87_401",
    x1: 0.310605,
    y1: 0.206907,
    x2: 19.8962,
    y2: 5.84154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_87_401",
    x1: 0.310605,
    y1: 0.206907,
    x2: 19.8962,
    y2: 5.84154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone_icon.520641b9554d173c8320aee71ed09899.svg";
export { ForwardRef as ReactComponent };